"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "albizzate": {
    "mirasole": [{
      "hkey": "1c8376df",
      "slug": "albizzate",
      "name": "Albizzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "89a36f00": [{
      "hkey": "1c8376df",
      "slug": "albizzate",
      "name": "Albizzate",
      "primary": true,
      "skipSearch": false
    }],
    "mora": [{
      "hkey": "1c8376df",
      "slug": "albizzate",
      "name": "Albizzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f7432940": [{
      "hkey": "1c8376df",
      "slug": "albizzate",
      "name": "Albizzate",
      "primary": true,
      "skipSearch": false
    }],
    "8ed577c3": [{
      "hkey": "1c8376df",
      "slug": "albizzate",
      "name": "Albizzate",
      "primary": true,
      "skipSearch": false
    }],
    "valdarno": [{
      "hkey": "1c8376df",
      "slug": "albizzate",
      "name": "Albizzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "tarabora": [{
      "hkey": "1c8376df",
      "slug": "albizzate",
      "name": "Albizzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fed0232a": [{
      "hkey": "1c8376df",
      "slug": "albizzate",
      "name": "Albizzate",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;